// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2-K6k","footer":"ModalError_footer__3fd3A"};